import { render, staticRenderFns } from "./ADeviceDetail8.vue?vue&type=template&id=01b35d0c&scoped=true"
import script from "./ADeviceDetail8.vue?vue&type=script&lang=js"
export * from "./ADeviceDetail8.vue?vue&type=script&lang=js"
import style0 from "./ADeviceDetail8.vue?vue&type=style&index=0&id=01b35d0c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b35d0c",
  null
  
)

export default component.exports